import {RouteRecordRaw} from "vue-router";
import StadiumsIndex from '../pages/Index.vue';

export const routes: RouteRecordRaw[] = [
  {
    path: '/stadiums',
    name: 'stadiums.index',
    component: StadiumsIndex,
  }
];